import React, { useState, DragEvent } from 'react';
import ApiDocument from '../code/api/ApiDocument';
import { Badge, Spinner } from "reactstrap";



interface IFileUploaderSingle {
  buttonTextChoose: string | undefined;
  buttonTextUpload: string | undefined;
  fileGroupId: number | undefined | null;
  fileGroup: string;
  newGroupOnUpload: boolean;
  onUploadStart: Function;
  onUploadSuccess(groupId: number);
  onUploadFail(groupId: number);
}

export default function FileUploaderSingle({ buttonTextChoose, buttonTextUpload, fileGroupId, fileGroup, newGroupOnUpload,
  onUploadStart, onUploadSuccess, onUploadFail }: IFileUploaderSingle) {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  async function handleUploadClick() {
    setUploading(true);
    onUploadStart();
    if (!fileGroupId || newGroupOnUpload) {
      ApiDocument.createFileGroup(fileGroup).then((res) => {
        if (!!res) {
          fileGroupId = res.bidPeriodFileGroupId;
          doDocumentUpload(fileGroupId);
        }
      });
    } else {
      doDocumentUpload(fileGroupId);
    }
  };

  function doDocumentUpload(groupId: number) {
    const formData = new FormData();
    if (file) {
      formData.append('file', file);

      ApiDocument.uploadDocuments(groupId, formData).then((res) => {
        if (res) {
          setFile(null);
          onUploadSuccess(groupId);
        } else {
          if (onUploadFail) {
            onUploadFail(groupId);
          }
        }
      }).finally(() => {
        setUploading(false);
      });
    }
  };

  const [dragStyle, setDragStyle] = useState<string>("");

  function handleFileDrop(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      var curFile = droppedFiles.item(0);

      if (curFile?.name.toLowerCase().endsWith(".pdf")) {
        setFile(curFile);
      }
    }
    setDragStyle("");
  }

  function handleDragging(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragStyle("drag-over");
  }

  function leaveDragging(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragStyle("");
  }

  return (
    <React.Fragment>
      <div className={"choose-group " + dragStyle} onDragOver={handleDragging} onDragEnter={handleDragging} onDragLeave={leaveDragging}
        onDrop={handleFileDrop}>
        {!uploading &&
          <React.Fragment>
            <label htmlFor="fileUploadInput" className="btn btn-outline-primary btn-md">{buttonTextChoose || "Choose File"} </label>
            <input id="fileUploadInput" type="file" accept='application/pdf' hidden={true} onChange={handleFileChange} />
          </React.Fragment>}<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        {!uploading && file &&<button onClick={handleUploadClick} className="btn btn-primary">{buttonTextUpload || "Upload File"}</button>}
        {!uploading && !file && <div className="upload-group">=======&gt; Drop Here! &lt;======</div>}        
        {uploading && <Badge color="info" className="fs-2"><Spinner>Loading...</Spinner><span>{' '}Loading</span></Badge>}
      </div>
      {file && (
        <section>
          <br />
          File details:
          <ul>
            <li>Name: {file.name}</li>
            <li>Type: {file.type}</li>
            <li>Size: {file.size} bytes</li>
          </ul>
        </section>
      )}
    </React.Fragment>
  );
};

